export default import.meta.ROLLDOWN_FILE_URL_Ij4Ii2U3cz0dqyeOEwXe4g